module.exports = __webpack_public_path__ + "c40eac6836c53daef055d219c9c8becd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/sushi.png
// module id = 2617
// module chunks = 0